import { AsyncPipe, isPlatformBrowser } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  Output,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutes } from '@app/core/routing';
import { User, UserState } from '@app/state';
import { ButtonComponent } from '@app/ui';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { HeaderAccountMenuComponent } from '../header-account-menu/header-account-menu.component';
import { HeaderActionsService } from '../header-actions.service';

export type HeaderNavActionsLayout = 'inline' | 'stack';

@Component({
  selector: 'gb-header-nav-actions',
  standalone: true,
  imports: [
    AsyncPipe,
    RouterModule,
    ButtonComponent,
    HeaderAccountMenuComponent,
  ],
  templateUrl: './header-nav-actions.component.html',
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
      }

      :host(.is-stacked) {
        display: block;
        width: 100%;
      }
    `,
  ],
})
export class HeaderNavActionsComponent {
  protected readonly AppRoutes = AppRoutes;

  /** Inline for desktop navbar; stack for drawer footers. */
  @Input() layout: HeaderNavActionsLayout = 'inline';
  @Input() showAccount = true;
  /** Sign-in label when unauthenticated. */
  @Input() signInLabel = 'Sign in';
  @Input() dashboardUrl = '/dashboard';

  @Output() menuAction = new EventEmitter<void>();

  private readonly store = inject(Store);

  user$: Observable<User> = this.store.select(UserState.user);

  isBrowser = false;

  @HostBinding('class.is-stacked')
  get hostStacked(): boolean {
    return this.layout === 'stack';
  }

  private headerActions = inject(HeaderActionsService);

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  get isAuthenticated(): boolean {
    return this.isBrowser && this.headerActions.isAuthenticated;
  }

  get isStacked(): boolean {
    return this.layout === 'stack';
  }

  onMenuAction(): void {
    this.menuAction.emit();
  }

  goToLogin(): void {
    this.menuAction.emit();
    this.headerActions.goToLogin();
  }

  fundraise(): void {
    this.headerActions.fundraiseWithAi(() => this.menuAction.emit());
  }
}
